$('.mc-embedded-subscribe-form').submit(function(e) {
    e.preventDefault();
    var frm = $(this);
    var email = frm.find(".mc-email").val();
    var btn = frm.find('[type="submit"]');
    var wait = frm.find('.mc-wait');
    btn.attr("disabled","");
    frm.find(".mc-target").val("");
    wait.show();
    $.post(
        ajaxurl,
        {
            'action': 'ajaxmailchimp',
            'email': email,
        },
        function(response){
            btn.removeAttr("disabled");
            wait.hide();
            if(response == "200"){
                $msg = "Votre demande d'abonnement a bien été prise en compte.";
                frm.find(".mc-target").removeClass("mc-target--error").addClass("mc-target--success");
                frm.find(".mc-email").val("");
            }else{
                $msg = "Une erreur est survenue, impossible d'ajouter votre email (code erreur : " + response + ")";
                frm.find(".mc-target").removeClass("mc-target--success").addClass("mc-target--error");
            }
            frm.find(".mc-target").html($msg);
        }
    );
    return false;
});


